import FundebIndex from "@/Pages/Fundeb/index.vue";
import semPermissaoFundeb from "@/router/guards/semPermissaoFundeb";

export default [
  {
    path: "/fundeb/calculadora",
    name: "fundeb.calculadora",
    component: FundebIndex,
    beforeEnter: async (to, from, next) => {
      await semPermissaoFundeb(to, from, next);
      return next();
    },
  },
];
